function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useMemo } from "react";
import { useSdkContext } from "~/components/contexts";
import { useNewsletterContext } from "~/components/newsletter/newsletter-widget/contexts";
import { getTriggerPoint } from "~/components/newsletter/newsletter-widget/sign-up-newsletter/helpers";
import { useFallbackStorageValue } from "~/lib/hooks";
import { getIsInWebView } from "~/lib/utils";
import { SignUpMatrixV1LocalStorageKey, SignUpNewsletterItemV1LocalStorageKey } from "./consts";
import { SocialType } from "./enums";
import { useSocialLogin } from "./hooks";
import EmailIcon from "./icon-email.svg";
import FacebookIcon from "./icon-facebook.svg";
import GoogleIcon from "./icon-google.svg";
import { Container, IconContainer } from "./styles";
export const SocialButtons = ({
  isAgreedReceiveMarketing,
  onEmailClick,
  ...props
}) => {
  const {
    campaignName,
    dataMatrix,
    newsletterItems,
    queryParametersForSocialButtons,
    variant
  } = useNewsletterContext();
  const {
    getSocialLoginUrl
  } = useSocialLogin();
  const {
    handleRoutePush,
    handleTrackGA4
  } = useSdkContext();
  const {
    set: setSubscriptionNewsletterItem
  } = useFallbackStorageValue(SignUpNewsletterItemV1LocalStorageKey);
  const {
    set: setSignUpMatrixV1LocalStorageKey
  } = useFallbackStorageValue(SignUpMatrixV1LocalStorageKey);
  const handleSocialButtonClick = socialType => {
    var _newsletterItems$0$na, _newsletterItems$0$na2;
    // Not setting these in querystring because of character limited in url
    setSubscriptionNewsletterItem(newsletterItems);
    setSignUpMatrixV1LocalStorageKey(dataMatrix);
    handleTrackGA4({
      action: "click",
      category: "nl",
      customized_parameters: {
        method: socialType,
        newsletter_name: (_newsletterItems$0$na = newsletterItems[0].name) !== null && _newsletterItems$0$na !== void 0 ? _newsletterItems$0$na : "",
        trigger_point: getTriggerPoint(variant)
      },
      subcategory: "sign_up"
    });
    const newsletterItemIds = newsletterItems.filter(item => item.entityId).map(item => item.entityId);
    void handleRoutePush(getSocialLoginUrl(socialType, {
      campaignName,
      newsletterIds: newsletterItemIds,
      newsletterName: (_newsletterItems$0$na2 = newsletterItems[0].name) !== null && _newsletterItems$0$na2 !== void 0 ? _newsletterItems$0$na2 : "",
      subscription: "true",
      triggerPoint: getTriggerPoint(variant),
      variant
    }, isAgreedReceiveMarketing), {
      query: queryParametersForSocialButtons
    });
  };
  const isInWebView = useMemo(() => getIsInWebView(), []);
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "data-qa": "social-buttons"
  }), /*#__PURE__*/React.createElement(IconContainer, {
    onClick: () => handleSocialButtonClick(SocialType.Facebook)
  }, /*#__PURE__*/React.createElement(FacebookIcon, {
    height: "100%",
    width: "22"
  })), !isInWebView && /*#__PURE__*/React.createElement(IconContainer, {
    onClick: () => handleSocialButtonClick(SocialType.Google)
  }, /*#__PURE__*/React.createElement(GoogleIcon, {
    height: "100%",
    width: "22"
  })), /*#__PURE__*/React.createElement(IconContainer, {
    onClick: onEmailClick
  }, /*#__PURE__*/React.createElement(EmailIcon, {
    height: "100%",
    width: "22"
  })));
};
SocialButtons.displayName = "SocialButtons";